<div class="modal-header">
    <h4 class="modal-title">
        {{ "international_projects.countries.sector" | translate }}
        <span class="fw-light mx-1">
            @if (displayLabel) {
                - {{ displayLabel }}
            }
        </span>
    </h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
</div>
<div class="modal-body" [formGroup]="model">
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="nameAE"
                formControlName="nameAE"
                [required]="true"
                [invalid]="submitted && model.get('nameAE')?.invalid!"
                [label]="'common.form.label.nameAE' | translate"
            />
        </div>
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="nameEN"
                formControlName="nameEN"
                [required]="true"
                [invalid]="submitted && model.get('nameEN')?.invalid!"
                [label]="'common.form.label.nameEN' | translate"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <adaa-form-input-file
                label="international_projects.countries.logo"
                [isDisabled]="isViewMode()"
                [allowedFileSize]="100024"
                [allowedFiles]="allowedFiles"
                [file]="getImage"
                (inputChanges)="onFilechange($event)"
            />
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>
    @if (!isViewMode()) {
        <button type="button" class="btn btn-primary" (click)="save()">{{ "common.form.button.save" | translate }}</button>
    }
</div>
